// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-medium":"#5e5e5e","title":"SpuifO9"};